// extracted by mini-css-extract-plugin
export default {"results-list-container":"ResultsList_results-list-container__OyU-p","results-table":"ResultsList_results-table__0oSYp"};